import { UserOptions, getInitialGADataLayerData, setGADataLayer, setUser, getUserLoginParameters } from 'analytics'
import { useContext, useLayoutEffect } from 'react'
import UserContext from '../contexts/user'
import TagManager from 'react-gtm-module'
import { useLocalStorage } from 'react-use'

const getUserType = (user) => {
    if (user.isArtist) {
        return 'artist'
    }

    if (user.isStaff) {
        return 'staff'
    }

    return 'user'
}

const GA4 = () => {
    const { user } = useContext(UserContext)
    const loginParams = getUserLoginParameters()
    const [loginMethod, setLoginMethod] = useLocalStorage('login_type', loginParams.platform || 'email')

    useLayoutEffect(() => {
        if (!user.isFetching) {
            let userProps: UserOptions = {
                userID: '',
                verifiedStatus: false,
                userType: '',
                loggedInStatus: false,
            }
            if (user) {
                userProps = {
                    userID: String(user.id),
                    userType: getUserType(user),
                    verifiedStatus: user.isVerified,
                    loggedInStatus: true,
                    loginMethod: loginParams.platform || loginMethod,
                }
            }

            setUser(userProps)
            if (loginParams.action) {
                setLoginMethod(loginParams.platform)
                setGADataLayer({
                    event: `${loginParams.action}_form_success`,
                    options: {
                        form: {
                            formName: loginParams.action,
                        },
                    },
                })
            }

            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(getInitialGADataLayerData())

            const tagManagerArgs = {
                gtmId: window.GTM_CONTAINER_ID,
            }

            TagManager.initialize(tagManagerArgs)
        }
    }, [user.isFetching])

    return <></>
}
export default GA4
